import { useId } from "react";
import type { ReactNode, SelectHTMLAttributes } from "react";

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label: string;
  children: ReactNode;
}

export function Select({ label, id, className = "", children, ...rest }: SelectProps) {
  const generatedId = useId();
  const fieldId = id ?? generatedId;
  return (
    <div className="flex flex-col gap-2">
      <label htmlFor={fieldId} className="type-label text-text-secondary">
        {label}
      </label>
      <select
        {...rest}
        id={fieldId}
        className={
          "h-11 w-full rounded-[var(--radius-control-sm)] bg-surface-sunken px-4 text-text-primary " +
          "border border-border-default transition-colors duration-[var(--duration-fast)] " +
          "hover:border-border-strong focus:border-accent focus:outline-none " +
          className
        }
      >
        {children}
      </select>
    </div>
  );
}
